import { useAppSelector } from '../../../../state/hooks'
import { Stack, Text } from '../../../../components/DesignSystem'

export default function ReviewAddress() {
	const { userLocation } = useAppSelector(state => state.user)

	return (
		<Stack gap="lg">
			<Text weight="semibold" tone="tertiary" level="large">
				DELIVERY ADDRESS
			</Text>
			<Text>{userLocation?.longAddress}</Text>
		</Stack>
	)
}
